// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 2H20V5C20 8.01203 18.3354 10.6353 15.876 12C18.3354 13.3647 20 15.988 20 19V22H4V19C4 15.988 5.66458 13.3647 8.124 12C5.66458 10.6353 4 8.01203 4 5V2ZM18 5V4H6V5C6 5.89221 6.19474 6.73894 6.54404 7.5H17.456C17.8053 6.73894 18 5.89221 18 5ZM11.002 13.0826C8.16328 13.5579 6 16.0263 6 19V20H7.10002C7.49783 18.0402 9.0419 16.4967 11.002 16.0996V13.0826ZM12.998 16.0996C14.9581 16.4967 16.5022 18.0402 16.9 20H18V19C18 16.0263 15.8367 13.5579 12.998 13.0826V16.0996Z"}}]};

const HourglassFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hourglass-filled',
    ref,
    icon: element,
  },
));

HourglassFilledIcon.displayName = 'HourglassFilledIcon';

export default HourglassFilledIcon;
